<div class="tab-section" [ngClass]="{'css-for-kcart': vars.showKCart}">
  <div #sharebtns *ngIf="!isMobile" class="social-share">
    <app-whatsapp-share class="fr-ended-share" backgroudColor="#25d366" color="#ffffff"
                        label="Share" [fundraiser]="fundraiser" [isFundraiserEnded]="isFundraiserEnded" [position]="2">
    </app-whatsapp-share>
    <app-fb-share class="fr-ended-share" label="Share" [position]="2"></app-fb-share>
    <app-donate-now *ngIf="!isFundraiserEnded" [label]="donateBtnLabel" [fundraiser]="fundraiser" [position]="2"></app-donate-now>
  </div>
  <mat-tab-group #tabs class="fr-tabs" (selectedTabChange)="tabChangeEvent($event)" [selectedIndex]="selectedTab">
    <!-- About Tab -->
    <mat-tab class="tabs" label="About">
      <ng-template mat-tab-label> <i class="icon-globe icomoon"></i> About </ng-template>
      <!-- <ng-template matTabContent> -->
        <app-about *ngIf="basicInfo?.social" [about]="basicInfo?.social" [isFundraiserEnded]="isFundraiserEnded"
                    [supporters]="supporters" [comments]="comments" [fundraiser]="fundraiser"
                    [updates]="checkLength(updates?.data)" [isLoading]="isLoading" [donateBtnLabel]="donateBtnLabel"
                    [sharedCounts]="sharedCounts" [donationCard]="donationCard" (changeTab)="getTabFromAbout($event)" [basicInfo]="basicInfo">
        </app-about>
      <!-- </ng-template> -->
    </mat-tab>
    <!-- Documents Tab -->
    <mat-tab *ngIf="(checkLength(fundraiser?.viewmedicalbill) || fundraiser?.count_medical_bill) && (!isFundraiserEnded || vars?.fundraiser?.isDonated)" label="Documents">
      <ng-template matTabLabel>
        <i class="icon-docs icomoon"></i> Documents
      </ng-template>
      <ng-template matTabContent>
        <div *ngIf="fundraiser?.count_medical_bill && !checkLength(fundraiser?.viewmedicalbill)" class="med-doc-place-holder">
          <app-component-loader [load]="true" selector="app-med-doc-place-holder"
            [inputs]="{position: 'doc-tab', sharedCounts: sharedCounts, fundraiser: fundraiser, isFundraiserEnded: isFundraiserEnded, basicInfo: basicinfo}"
          />
        </div>
        <app-document *ngIf="checkLength(fundraiser?.viewmedicalbill)" [documents]="fundraiser?.viewmedicalbill" [sharedCounts]="sharedCounts"
                      [fundraiser]="fundraiser" [isFundraiserEnded]="isFundraiserEnded" [basicInfo]="basicInfo" position="medical-doc-tab" class="fr-document">
        </app-document>
      </ng-template>
    </mat-tab>
    <!-- Team Tab -->
    <mat-tab *ngIf="checkTeam(fundraiser?.activeteam)">
      <ng-template matTabLabel>
        <i class="icon-users icomoon"></i>
        <span>Team</span>
      </ng-template>
      <ng-template matTabContent>
        <app-team [team]="fundraiser?.activeteam" [rewards]="fundraiser?.rewards"
                  [isFundraiserEnded]="isFundraiserEnded" [sharedCounts]="sharedCounts">
        </app-team>
      </ng-template>
    </mat-tab>
    <!-- Updates tab -->
    <mat-tab label="Updates">
      <ng-template matTabLabel>
        <i class="icon-update icomoon"></i>
        <span>Updates</span>
        <span class="tab-badge" *ngIf="updates?.total">{{updates?.total}}</span>
      </ng-template>
      <!-- <ng-template matTabContent> -->
        <app-update *ngIf="checkForVisitedTabs('Updates')" [fundraiser]="fundraiser" [updates]="updates" [updateCounts]="updates?.total"
                    [isFundraiserEnded]="isFundraiserEnded" [basicInfo]="basicInfo"
                    [sharedCounts]="sharedCounts" [isDonated]="isDonated" pageName="campaing"
                    [viewMore]="updates?.next_page_url ? true : false" [showCommentList]="false">
        </app-update>
      <!-- </ng-template> -->
    </mat-tab>
    <!-- Supporters tab -->
    <mat-tab *ngIf="checkLength(supporters?.supporters?.data) && isMobile && (!isFundraiserEnded || vars?.fundraiser?.isDonated)" label="Supporters">
      <ng-template matTabLabel>
        <span>Supporters</span>
        <span class="tab-badge">{{fundraiser?.raised?.backers}}</span>
      </ng-template>
      <ng-template matTabContent>
        <app-supporter [supporters]="supporters" [donateBtnLabel]="donateBtnLabel"
                      [isFundraiserEnded]="isFundraiserEnded" [fundraiser]="fundraiser"
                      [isLoading]="isLoading" [settings]="fundraiser?.settings">
        </app-supporter>
      </ng-template>
    </mat-tab>
    <!-- Comments Tab -->
    <mat-tab label="Comments">
      <ng-template matTabLabel>
        <i class="icon-comment icomoon"></i>
        <span>Comments</span>
        <span class="tab-badge">{{counts}}</span>
      </ng-template>
      <ng-template matTabContent>
        <app-comment [comments]="comments" [fundraiser]="fundraiser"></app-comment>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>
